import * as $ from 'jquery';

class ComponentsController {
  constructor() {    
    $(document).ready(function() {
      if ($("[data-component='kandidaten-overzicht']").length > 0) {
        import('./components/kandidaten-overzicht').then(function(functionality) {  
          functionality.init();
      });   
      }
    });
  }
}
export { ComponentsController };